// File: /src/components/dashboard/SummaryBarChart.js

import React from 'react';
import {
	ResponsiveContainer,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	Tooltip,
	Legend,
} from 'recharts';
import { FaChartBar } from 'react-icons/fa';

const CustomTooltip = ({ active, payload }) => {
	if (active && payload && payload.length) {
		const { name, value } = payload[0].payload;
		return (
			<div className="custom-tooltip">
				<strong>{`${name}: ${value}`}</strong>
			</div>
		);
	}
	return null;
};

const SummaryBarChart = ({ data }) => (
	<div className="chart-container">
		<div className="header-section">
			<div className="card-icon">
				<FaChartBar size={16} />
			</div>
			<h2>Resumo Geral</h2>
		</div>
		<div className="chart-content">
			<ResponsiveContainer width="100%" height="100%">
				<BarChart
					data={data}
					margin={{ top: 10, right: 30, left: 20, bottom: 5 }}
				>
					<XAxis
						dataKey="name"
						tick={{
							fontSize: 12,
							fontFamily: 'Plus Jakarta Sans',
							fill: 'var(--chart-text, #1a365d)',
						}}
					/>
					<YAxis
						tickFormatter={(tick) =>
							Number.isInteger(tick) ? tick : ''
						}
						allowDecimals={false}
						tick={{
							fontSize: 12,
							fontFamily: 'Plus Jakarta Sans',
							fill: 'var(--chart-text, #1a365d)',
						}}
					/>
					<Tooltip content={<CustomTooltip />} />
					<Legend
						formatter={() => 'Total'}
						wrapperStyle={{
							fontFamily: 'Plus Jakarta Sans',
							fontSize: '0.9rem',
							color: 'var(--chart-text, #1a365d)',
						}}
					/>
					<Bar
						dataKey="value"
						fill="#1a365d"
						radius={[4, 4, 0, 0]}
						maxBarSize={100}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	</div>
);

export default SummaryBarChart;
